import FetcherError from './FetcherError.js'

export default class FetcherErrorsFactory {
  static fetcherError = msg => new FetcherError(msg)
}
